export enum RectDirection {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right'
}
